import { useRef, useEffect, useCallback } from 'react';

// This is a SWR middleware for keeping the previous data even if key changes
// ref: https://swr.vercel.app/docs/middleware#keep-previous-result
function keepPreviousResult(useSWRNext) {
  return (key, fetcher, config) => {
    const laggyDataRef = useRef();
    const swr = useSWRNext(key, fetcher, config);

    useEffect(() => {
      if (swr.data !== undefined) {
        laggyDataRef.current = swr.data;
      }
    }, [swr.data]);

    // Expose a method to clear the laggy data, if any.
    const resetLaggy = useCallback(() => {
      laggyDataRef.current = undefined;
    }, []);

    const dataOrLaggyData =
      swr.data === undefined ? laggyDataRef.current : swr.data;

    const isLagging =
      swr.data === undefined && laggyDataRef.current !== undefined;

    // Also add a `isLagging` field to SWR.
    return { ...swr, data: dataOrLaggyData, isLagging, resetLaggy };
  };
}

export default keepPreviousResult;
